import { useMemo, useState } from 'react';
import {
  DisplayModeContext,
  DisplayModeContextType,
} from './DisplayModeContext';

interface DisplayModeProviderProps {
  children: React.ReactNode;
}

export const DisplayModeProvider = ({ children }: DisplayModeProviderProps) => {
  const [displayMode, setDisplayMode] = useState<'compact' | 'expanded'>(
    'expanded'
  );
  const [isAnimating, setIsAnimating] = useState(false);

  const contextValue: DisplayModeContextType = useMemo(
    () => ({
      displayMode,
      setDisplayMode,
      isAnimating,
      setIsAnimating,
    }),
    [displayMode, isAnimating]
  );

  return (
    <DisplayModeContext.Provider value={contextValue}>
      {children}
    </DisplayModeContext.Provider>
  );
};
